import { css } from '@emotion/react';
import theme from 'shared/styles/themes';

export default css({
  '&.selected-file-actions': {
    alignItems: 'start',
    flexWrap: 'wrap',
    '& > *': {
      marginRight: theme.space[4],
    },
  },
});
